// extracted by mini-css-extract-plugin
export default {"fai":"cell_fai__vEgAv","red":"cell_red__hjgL0","gray":"cell_gray__S3N1E"};